import api from '@/services/api';

interface OtpStatusResponse {
  success: boolean;
  data: {
    exists: boolean;
    timeLeft: number; // seconds remaining
  };
}

/**
 * Check if a valid OTP exists for the given identifier
 * @param identifier - Phone number or email
 * @param isEmail - Whether identifier is email
 * @returns Object with exists flag and time left
 */
export async function checkOtpStatus(
  identifier: string,
  isEmail: boolean,
): Promise<{ exists: boolean; timeLeft: number }> {
  try {
    const params = new URLSearchParams({
      identifier,
      isEmail: isEmail.toString(),
    });
    const result = await api.get<OtpStatusResponse>(`/otp/status?${params.toString()}`, undefined, {
      showErrorToast: false,
    });
    return result.data;
  } catch (error) {
    console.error('Error checking OTP status:', error);
    return { exists: false, timeLeft: 0 };
  }
}

/**
 * Clear OTP cache after successful verification
 * @param identifier - Phone number or email
 * @param isEmail - Whether identifier is email
 */
export async function clearOtpCache(identifier: string, isEmail: boolean): Promise<void> {
  try {
    await api.post('/otp/clear', { identifier, isEmail }, { showErrorToast: false });
  } catch (error) {
    console.error('Error clearing OTP cache:', error);
  }
}
